import messages from '@/constants/messages'
import routes from '@/internal/constants/routes'

type ModelConfig = {
  label: string
  button: string
  buttonAll: string
  buttonAllUrl?: string
}

const config: Record<string, ModelConfig> = {
  DatoCmsPctDialog: {
    label: messages.labelDialog,
    button: messages.buttonDialogViewContent,
    buttonAll: messages.buttonDialogViewAllContent,
    buttonAllUrl: routes.dialogsRoute
  },
  DatoCmsPctPaper: {
    label: messages.labelPaper,
    button: messages.buttonPaperViewContent,
    buttonAll: messages.buttonPaperViewAllContent,
    buttonAllUrl: routes.papersRoute
  },
  DatoCmsPctPost: {
    label: messages.labelPost,
    button: messages.buttonPostViewContent,
    buttonAll: messages.buttonPostViewAllContent,
    buttonAllUrl: routes.postsRoute
  },
  DatoCmsPctInterview: {
    label: messages.labelInterview,
    button: messages.buttonInterviewViewContent,
    buttonAll: messages.buttonInterviewViewAllContent,
    buttonAllUrl: routes.interviewsRoute
  },
  DatoCmsPctProject: {
    label: messages.labelProject,
    button: messages.buttonProjectViewContent,
    buttonAll: messages.buttonProjectViewAllContent,
    buttonAllUrl: routes.projectsRoute
  },
  DatoCmsPctPage: {
    label: messages.labelPage,
    button: messages.buttonPage,
    buttonAll: messages.buttonPaperViewAllContent
  },
  DatoCmsPctTopic: {
    label: messages.labelTopic,
    button: messages.buttonTopic,
    buttonAll: messages.buttonTopic
  },
  DatoCmsPctTag: {
    label: messages.labelTag,
    button: messages.buttonTag,
    buttonAll: messages.buttonTag
  },
  DatoCmsPctInternalPage: {
    label: messages.labelInternalPage,
    button: messages.buttonInternalPage,
    buttonAll: messages.buttonInternalPage
  },
  DatoCmsPctVision: {
    label: messages.labelVision,
    button: messages.buttonVision,
    buttonAll: messages.buttonVision
  },
  DatoCmsPctReport: {
    label: messages.labelReport,
    button: messages.buttonReport,
    buttonAll: messages.buttonReport
  },
  DatoCmsPctEpisode: {
    label: messages.labelEpisode,
    button: messages.buttonEpisode,
    buttonAll: messages.buttonEpisodeViewAllContent,
    buttonAllUrl: routes.episodesRoute
  },
  DatoCmsPctExternalContent: {
    label: messages.labelExternalContent,
    button: messages.buttonDefault,
    buttonAll: messages.buttonExternalViewAllContent
  },
  DatoCmsPctEvent: {
    label: messages.labelEvent,
    button: messages.buttonEvent,
    buttonAll: messages.buttonEventViewAllContent,
    buttonAllUrl: routes.eventsRoute
  }
}

export const getModelMessages = (
  typename: string | undefined | null
): ModelConfig => {
  if (typename == null) {
    return { label: '', button: '', buttonAll: '', buttonAllUrl: '' }
  }
  return config[typename] ?? {}
}
